// extracted by mini-css-extract-plugin
module.exports = {"statistics":"Statistics_statistics__2zqQp","title":"Statistics_title__17_M7","wrapper":"Statistics_wrapper__1-oUL","percent":"Statistics_percent__2aOmS"};